import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import AceEditor from 'react-ace'
import yaml from 'js-yaml'

import 'brace/mode/yaml'
import 'brace/theme/github'

export default class ConfigField extends Component {
  constructor(props) {
    super(props)

    let value = this.getValue(props)
    this.state = {
      value,
      initialized: value === '',
    }
  }

  componentDidUpdate = ({ name: prevName }) => {
    let { name, value } = this.props
    let { initialized } = this.state

    if (prevName !== name || (!initialized && value !== ''))
      this.setState({
        value: this.getValue(this.props),
        initialized: true,
      })
  }

  getValue = props => {
    let { value = {} } = props

    if (Map.isMap(value) || List.isList(value)) value = value.toJS()

    if (typeof value === 'string')
      value = {
        conditions: [],
      }

    try {
      return yaml.safeDump(value)
    } catch (err) {
      console.log(err)
      return ''
    }
  }

  handleSave = () => {
    let { value } = this.state
    let { name, onChange } = this.props

    try {
      onChange({ name, value: yaml.safeLoad(value) })
    } catch (err) {
      console.log(err)
    }
  }

  render() {
    let { name, onChange } = this.props
    let { value } = this.state

    return (
      <div className="form-field-config">
        <AceEditor
          mode="yaml"
          theme="github"
          value={value}
          name={name}
          onChange={value => this.setState({ value })}
          onBlur={() => this.handleSave()}
          height="300px"
          width="100%"
          tabSize={2}
          editorProps={{ $blockScrolling: true }}
        />
      </div>
    )
  }
}
